module.exports = __webpack_public_path__ + "img/1m.6bacbc40.jpg";